module.exports = __webpack_public_path__ + "static/media/image-12.7b717a40.png";